import { put, call } from 'redux-saga/effects';
import { assUserActivate,assUserEdit,assUserUpdate,assUserDelete,assUserList,assUserAdd,assMutePush,assMuteEmail } from '../services/assUserService';
import { departmentList } from '../services/commonService';
import { rolesList } from '../services/rolesPermissionsService';

import * as types from '../actions';


export function* assUserAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(assUserAdd, payload);
    yield put({ type: types.ASS_USER_ADD_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ASS_USER_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* assUserEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(assUserEdit, payload);
    yield put({ type: types.ASS_USER_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ASS_USER_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* assUserUpdateSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(assUserUpdate, payload);
      yield put({ type: types.ASS_USER_UPDATE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.ASS_USER_UPDATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
  
export function* assUserDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(assUserDelete, payload);
    yield put({ type: types.ASS_USER_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ASS_USER_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* assUserActivateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(assUserActivate, payload);
    yield put({ type: types.ASS_USER_ACTIVATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ASS_USER_ACTIVATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* associateUserDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(assUserDelete, payload);
    yield put({ type: types.ASSOCIATE_USER_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ASSOCIATE_USER_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* assUserListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(assUserList, payload);
    yield put({ type: types.ASS_USER_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ASS_USER_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* assUserDepartmentListSaga(payload) { 
  try {
    const response = yield call(departmentList, payload);
    yield put({ type: types.DEPARTMENT_LIST_ASSOC_USER_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DEPARTMENT_LIST_ASSOC_USER_ERROR, error });
  }
} 

export function* assUserRolesListSaga(payload) {
  try {
    const response = yield call(rolesList, payload);
    yield put({ type: types.ROLES_LIST_ASSOC_USER_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ROLES_LIST_ASSOC_USER_ERROR, error });
  }
}

export function* assMuteEmailSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(assMuteEmail, payload);
    yield put({ type: types.UPDATE_ASSO_MUTE_EMAIL_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.UPDATE_ASSO_MUTE_EMAIL_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* assMutePushSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(assMutePush, payload);
    yield put({ type: types.UPDATE_ASSO_MUTE_PUSH_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.UPDATE_ASSO_MUTE_PUSH_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

